import { motion } from 'framer-motion'
import useReducedMotion from '../../hooks/useReducedMotion'

/**
 * Markaziy diamond + ikki tomonida chiziq — section divider.
 */
export default function DividerOrnament({ className = '' }) {
  const reduced = useReducedMotion()

  return (
    <div className={`flex items-center justify-center gap-4 text-white/40 ${className}`} aria-hidden="true">
      <motion.span
        className="h-px bg-current flex-1 max-w-[180px]"
        initial={reduced ? false : { scaleX: 0, originX: 1 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.span
        initial={reduced ? false : { opacity: 0, rotate: 0, scale: 0 }}
        whileInView={{ opacity: 1, rotate: 45, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        className="inline-block w-2.5 h-2.5 border border-current"
      />
      <motion.span
        className="h-px bg-current flex-1 max-w-[180px]"
        initial={reduced ? false : { scaleX: 0, originX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      />
    </div>
  )
}
